import { TEST_IDS } from '@va/constants';
import { memo } from 'react';

type YearProps = {
  years: number[];
  setYear: (year: number) => void;
};

export const Year = memo(({ years, setYear }: YearProps) => {
  return (
    <div className='flex flex-wrap' data-tesid={TEST_IDS.generic.datePicker.yearsPanel}>
      {years.map((year) => {
        return (
          <div key={year} className='w-1/2 px-0.5'>
            <span className='flex rounded-md mt-1.5'>
              <button
                type='button'
                className='btn-class relative px-3 py-2 block w-full leading-6 rounded-md bg-white text-xs 2xl:text-sm tracking-wide font-medium transition-colors uppercase border border-transparent hover:bg-white-snow focus:bg-primary-50 focus:border-primary focus:ring-1 focus:ring-primary focus:outline-hidden '
                onClick={() => setYear(year)}
                data-testid={TEST_IDS.generic.datePicker.yearOption(year)}
              >
                {year}
              </button>
            </span>
          </div>
        );
      })}
    </div>
  );
});
